/**
 * Initializes the custom cursor that tracks the mouse
 * and shows contextual labels on interactive regions.
 */
export function initCursor() {
  const cursor = document.querySelector('.custom-cursor');
  if (!cursor) return;

  document.addEventListener('mousemove', (e) => {
    cursor.style.left = e.clientX + 'px';
    cursor.style.top = e.clientY + 'px';
  });

  /**
   * Registers hover-text behavior on an element.
   * @param {HTMLElement} el
   * @param {string} hoverText
   */
  function registerCursor(el, hoverText) {
    if (!el) return;
    el.addEventListener('mouseenter', () => {
      cursor.classList.add('active');
      cursor.innerHTML = hoverText;
    });
    el.addEventListener('mouseleave', () => {
      cursor.classList.remove('active');
    });
    el.addEventListener('pointerdown', () => {
      cursor.style.transform = 'translate(-50%, -50%) scale(0.8)';
    });
    el.addEventListener('pointerup', () => {
      cursor.style.transform = 'translate(-50%, -50%) scale(1)';
    });
  }

  return { registerCursor };
}
